import React from 'react';
import Editor from 'pureUi/Editor';
import { SlideToggle } from 'ui/SlideToggle';

interface IHideableTextEditorProps {
  label: string;
  text: string;
  isVisible: boolean;
  onTextChange: (text: string) => void;
  onVisibilityChange: (isVisible: boolean) => void;
  placeholder?: string;
  className?: string;
  isLabelVisible?: boolean;
}

export const HideableTextEditor: React.FC<IHideableTextEditorProps> = ({
  label,
  text,
  isVisible,
  onTextChange,
  onVisibilityChange,
  isLabelVisible = true,
  placeholder = 'Write here more info ...',
  className = '',
}) => {
  const toggleId = `toggle-${label.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <div className={`mb-6 ${className}`}>
      {isLabelVisible && (
        <span className="font-pt-sans my-0 mb-5px w-full text-black pb-2 text-13px font-normal block">{label}</span>
      )}
      <div className="flex items-center gap-4">
        <div className="flex-1 relative">
          <Editor
            handleEditorChange={onTextChange}
            text={text}
            options={[]}
            placeHolder={placeholder}
            minHeight="125px"
            initVals={{
              autoresize_bottom_margin: 0,
              min_height: 125,
            }}
          />
        </div>

        <SlideToggle
          id={toggleId}
          checked={isVisible}
          onActivate={() => onVisibilityChange(true)}
          onDeactivate={() => onVisibilityChange(false)}
          labelClassName={!isVisible ? 'bg-gray-20' : 'bg-teal-40'}
          buttonClassName={!isVisible ? 'bg-gray-100' : 'bg-teal-100'}
        />
      </div>
    </div>
  );
};
